import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { PhotoProvider } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import { BrowserRouter } from "react-router";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <PhotoProvider>
                <App />
            </PhotoProvider>
        </BrowserRouter>
    </React.StrictMode>
);
